<template>
  <div class="ext-app-wrapper">
    <div v-if="showHeader" class="app-header-wrapper">
      <div class="header-left">
        <!--        <div class="button" @click="handleLastPageClick"><a-icon type="arrow-left" /></div>-->
        <!--        <div class="button" @click="handleNextPageClick"><a-icon type="arrow-right" /></div>-->
      </div>
      <div class="header-center">
        {{ $route.meta.title }}
      </div>
      <div class="header-right">
        <div
          v-if="appData.isAdmin && appData?.systemAdminUrl"
          class="button"
          @click="handleAdminClick(appData?.systemAdminUrl)"
        >
          <a-icon type="desktop" />
        </div>
        <div class="button" @click="handleRefreshClick()">
          <a-icon type="redo" />
        </div>
      </div>
    </div>
    <div class="iframe-wrapper">
      <zjy-loading v-if="loading" />
      <iframe
        v-show="!loading"
        :id="code"
        v-if="urlWithTicket"
        :src="urlWithTicket"
        ref="frame"
        @load="onIframeLoad"
      >
      </iframe>
    </div>
  </div>
</template>

<script>
import { getAppDetail } from "@/api/admin/app";
import { getSsoTicket } from "@/api/auth";
import { mapGetters } from "vuex";
import ZjyLoading from "@/components/zjy/ZjyLoading.vue";

export default {
  name: "AppLayout",
  components: { ZjyLoading },
  props: {
    url: {
      type: String,
      default: "",
    },
    code: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      loading: false,
      appData: {},
      indicator: <a-icon type="loading" style="font-size: 24px" spin />,
      urlWithTicket: "",
      showHeader: true,
    };
  },
  watch: {
    url(newUrl) {
      if (newUrl && this.appData && this.appData.id) {
        this.loading = true;
        getSsoTicket({
          appId: this.appData.id,
          redirectUrl: newUrl,
        }).then((res) => {
          if (res.success) {
            this.urlWithTicket = res.data;
          }
        });
      }
    },
  },
  computed: {
    ...mapGetters(["userInfo", "info"]),
  },
  mounted() {
    if (this.code) {
      this.loading = true;
      getAppDetail({ appCode: this.code }).then((res) => {
        if (res.success) {
          if (res.data) {
            this.appData = res.data;
            if (this.url) {
              this.appData.pcUrl = this.url;
            }
            if (this.appData.pcUrl) {
              const param = {
                appId: this.appData.id,
                redirectUrl: this.appData.pcUrl,
              };
              getSsoTicket(param).then((res) => {
                if (res.success) {
                  this.urlWithTicket = res.data;
                }
              });
            }
          }
        }
      });
    }
  },
  methods: {
    onIframeLoad() {
      this.loading = false;
    },
    postMessageToIframe(action) {
      const iframe = this.$refs.frame;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(action, "*");
      }
    },
    handleRefreshClick() {
      this.postMessageToIframe("refresh");
    },
    handleAdminClick(adminUrl) {
      window.open(adminUrl);
    },
  },
};
</script>

<style lang="less" scoped>
.ext-app-wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  .app-header-wrapper {
    width: 100%;
    height: 40px;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #e5e6e8;

    .header-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 150px;
      margin-left: 15px;

      .button {
        margin-right: 15px;
        cursor: pointer;
        font-size: 16px;
        color: #2c3e50;
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        border-radius: 4px;
        justify-content: center;
        &:hover {
          background: rgb(233, 234, 235);
        }
      }
    }

    .header-center {
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      font-weight: bold;
    }

    .header-right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 150px;
      margin-right: 15px;

      .button {
        margin-left: 15px;
        cursor: pointer;
        font-size: 18px;
        color: #2c3e50;
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        &:hover {
          background: rgb(233, 234, 235);
        }
      }
    }
  }

  .iframe-wrapper {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;

    iframe {
      flex: 1;
      width: 100%;
      height: 100%;
      border: 0;
      display: block;
    }
  }
}
</style>
